import _ from 'lodash';

const TERM_VALUE_PROP_NAMES = [
    'directBooleanValue',
    'directDateValue',
    'directStringValue',
    'directValue',
    'chosenTerm'
];

const READ_ONLY_CLAUSE_TERMS = [
    'UMBUmbrellaCovHandRatedPremium'
];

function getTermValue(term) {
    const valueProp = TERM_VALUE_PROP_NAMES.find((propName) => _.get(term, propName));
    return _.get(term, valueProp);
}

function isClauseValid(clause) {
    const isClauseSelected = clause.selected;
    const areTermsValid = clause.terms.every((term) => {
        return term.required ? getTermValue(term) : true;
    });

    return isClauseSelected ? areTermsValid : true;
}

function getInvalidClauses(clauses = []) {
    return clauses.filter((clause) => !isClauseValid(clause)).map((clause) => clause.publicID);
}

function isClauseTermReadOnly(clausePublicID) {
    return READ_ONLY_CLAUSE_TERMS.includes(clausePublicID);
}

export default {
    getInvalidClauses, isClauseTermReadOnly
};